import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class MsrCardService {
  public server = environment.APIEndpoint;
  public deviceMetaInfo = {
    "appVersion": "",
    "deviceCountry": "India",
    "deviceCity": "",
    "deviceId": localStorage.getItem("deviceId"),
    "deviceModel": "",
    "platform": "WEB",
    "deviceOSVersion": ""
  };
  public urls: any = {
    getAllMSRCards: this.server + 'api/msrcard/v1/list',
    msrCardSettings: this.server + 'api/user/msrcard/settings',
    initiateSecureGiftCardPayment: this.server + 'api/compose/egift/card/details/v1',
    initiateUnsecGiftCardPayment: this.server + 'api/unsec/user/msrcard/egift/v1/initiate',
  };
  public secHeaderData = {
    'Authorization': 'Bearer ' + this.storageService.getAccessToken(),
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
  };
  public unsecHeaderData = {
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo),
    'GuestToken': localStorage.getItem('guestUserToken')
  };
  constructor(private http: HttpClient, private apiHeader: ApiHeaderService, private storageService: StorageService,
  ) {
  }
  getAllMSRCards() {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.getAllMSRCards, { headers: secHeaders });
  }
}
